import { render, staticRenderFns } from "./addGoodsDrawer.vue?vue&type=template&id=a9968588&scoped=true"
import script from "./addGoodsDrawer.vue?vue&type=script&lang=js"
export * from "./addGoodsDrawer.vue?vue&type=script&lang=js"
import style0 from "./addGoodsDrawer.vue?vue&type=style&index=0&id=a9968588&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9968588",
  null
  
)

export default component.exports